var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 7.5H14.5455V4H1.81818C0.818182 4 0 4.7875 0 5.75V15.375H1.81818C1.81818 16.8275 3.03636 18 4.54545 18C6.05455 18 7.27273 16.8275 7.27273 15.375H12.7273C12.7273 16.8275 13.9455 18 15.4545 18C16.9636 18 18.1818 16.8275 18.1818 15.375H20V11L17.2727 7.5ZM4.54545 16.6875C3.79091 16.6875 3.18182 16.1012 3.18182 15.375C3.18182 14.6488 3.79091 14.0625 4.54545 14.0625C5.3 14.0625 5.90909 14.6488 5.90909 15.375C5.90909 16.1012 5.3 16.6875 4.54545 16.6875ZM16.8182 8.8125L18.6 11H14.5455V8.8125H16.8182ZM15.4545 16.6875C14.7 16.6875 14.0909 16.1012 14.0909 15.375C14.0909 14.6488 14.7 14.0625 15.4545 14.0625C16.2091 14.0625 16.8182 14.6488 16.8182 15.375C16.8182 16.1012 16.2091 16.6875 15.4545 16.6875Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrive);
export default __webpack_public_path__ + "static/media/icon-drive.a3d15384d08b78f3d3a0d63e3df19ef9.svg";
export { ForwardRef as ReactComponent };